import { GetComponentProps } from 'topwrite';
import { getTas } from '@/utils';

let icons;

const getIcons = () => {

    if (icons !== undefined) {
        return icons;
    }

    const tas = getTas();

    throw new Promise(async (resolve, reject) => {
        try {
            icons = await tas.getIcons();
            resolve(true);
        } catch {
            icons = [];
            reject();
        }
    });
};

const getIconComponent = (name: string) => {
    const icon = getIcons().find(icon => icon.name === name);

    if (icon) {
        return icon.Component;
    }
    return null;
};

const Icon = ({ name }: { name: string }) => {

    const Component = getIconComponent(name);

    if (!Component) {
        return null;
    }
    return <Component />;
};

export default function Items({ Component }: GetComponentProps<'page:menu:item'>) {
    const tas = getTas();

    const { customs, chat, feedback } = tas.getConfig();

    return <>
        {customs.map((custom, index) => {
            return <Component
                key={`custom-${index}`}
                tooltip={custom.title}
                onClick={() => {
                    tas.toggleCustom(index);
                }}
            >
                <Icon name={custom.icon} />
            </Component>;
        }).reverse()}
        {feedback && <Component
            tooltip={'反馈建议'}
            onClick={() => {
                tas.toggleFeedback();
            }}
        >
            <Icon name={'feedback'} />
        </Component>}
        {chat.enable && <Component
            tooltip={'在线客服'}
            onClick={() => {
                tas.toggleChat();
            }}
        >
            <Icon name={'chat'} />
        </Component>}
    </>;
}
